
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import styles from './index.module.scss';
import Layout from '../../components/Layout';
import { Namespace } from '../../enums/namespaces';
import { StaticPathParams } from '../../typings/staticPaths';
import classNames from 'classnames';
import Trans from 'next-translate/Trans';
import AppLink from 'components/AppLink/AppLink';
import Head from 'next/head';
import { basicSEO } from 'helpers/jsx';
import { withForcePlanToLoggedInUnsubs } from 'context';
import { createRedirectIfNeeded, Permalink } from 'helpers';
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { useLang } from 'context/langContext';
import { GenreBase } from 'typings/api';
import priceConfig from 'config/prices';

interface Props {
  relatedGenre: GenreBase;
  studentMonthlyPrice: string;
  studentMonthlyPercentageDiscount: number;
  priceMonthly: string;
  countryCode: string;
}

const Schools: NextPage<Props> = ({
  relatedGenre,
  studentMonthlyPrice,
  studentMonthlyPercentageDiscount,
  priceMonthly,
  countryCode,
}) => {
  const { t } = useTranslation(Namespace.Schools);
  const { locale } = useLang();

  return (
    <Layout countryCode={countryCode}>
      <Head>{basicSEO(t('seo:for_schools_title'), t('seo:for_schools_description'))}</Head>
      <main className={classNames(styles.welcome, styles.register, styles.vouchersLanding, styles.forSchools)}>
        <div className={styles.registerWrapper}>
          <div className={styles.students}></div>
          <div className={styles.topLeft}>
            <h1>{t('forschools_title')}</h1>
            <p className="text-center">{t('forschools_description')}</p>
            <a className={classNames(styles.btn, 'btn', 'btn-primary')} href="mailto:skoly@dramox.cz">
              {t('forschools_button')}
            </a>
          </div>
        </div>
        <div className={styles.price}>
          <p className="mb-0">
            <Trans
              i18nKey={'schools:forschools_obligatory'}
              components={[
                <AppLink href={Permalink.genre(relatedGenre, locale)}>
                  <a />
                </AppLink>,
              ]}
            />
          </p>
          <div>
            <h2>{t('forschools_price', { studentMonthly: studentMonthlyPrice })}</h2>
            <p>{t('forschools_price_desc')}</p>
          </div>
        </div>
        <div className={styles.tiles}>
          <div className={styles.tileCol}>
            <div className={styles.tile}>
              <h3>{t('forschools_student_price_title')}</h3>
              <p>
                {t('forschools_student_price_desc', {
                  monthly: priceMonthly,
                  studentMonthly: studentMonthlyPrice,
                  studentMonthlyPercentageDiscount,
                })}
              </p>
            </div>
            <div className={styles.tile}>
              <div className={classNames(styles.iconWrapper, styles.school)}>icon ticket</div>
              <h3>{t('forschools_for_who_title')}</h3>
              <p>
                {t('forschools_for_who_desc_1')}
                <br />
                <br />

                <Trans
                  i18nKey={'schools:forschools_for_who_desc_2'}
                  components={[<a href="mailto:skoly@dramox.cz" />]}
                />
              </p>
            </div>
          </div>
          <div className={styles.tileCol}>
            <div className={styles.tile}>
              <div className={classNames(styles.iconWrapper, styles.dramox)}>icon ticket</div>
              <h3>{t('forschools_for_class_title')}</h3>
              <ol>
                <li>
                  <Trans
                    i18nKey={'schools:forschools_for_class_desc_1'}
                    components={[<a href="mailto:skoly@dramox.cz" />]}
                  />
                </li>
                <li>
                  {t('forschools_for_class_desc_2_1')} <br />
                  <br />
                  {t('forschools_for_class_desc_2_2')}
                </li>
                <li>{t('forschools_for_class_desc_3')}</li>
                <li>{t('forschools_for_class_desc_4')}</li>
                <li>{t('forschools_for_class_desc_5')}</li>
              </ol>
            </div>
          </div>
        </div>
        <div className={styles.buySection}>
          <h2>{t('forschools_title')}</h2>
          <p>{t('forschools_bottom_desc', { studentMonthly: studentMonthlyPrice })}</p>

          <a className={classNames(styles.btn, 'btn', 'btn-primary')} href="mailto:skoly@dramox.cz">
            {t('forschools_button')}
          </a>
        </div>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { apiClient, locale, countryCode } = await authorizeUserServerSide(ctx);

  const genres = await apiClient.getGenres();

  let priceMonthly: string;
  let studentMonthlyPrice: string;
  let studentMonthlyPercentageDiscount: number;
  const plans = await apiClient.getPlans();
  const planMonthly = plans.find((p) => p.recurrence.unit === 'MONTH' && p.recurrence.length === 1);

  if (planMonthly) {
    priceMonthly = planMonthly.price.formatted;
    const currency = planMonthly.price.currency;
    studentMonthlyPrice = priceMonthly
      .replace(',', '.')
      .replace(planMonthly.price.value.toString(), priceConfig[currency].studentMonthlyPrice.toString());
    studentMonthlyPercentageDiscount = priceConfig[currency].studentPercentageDiscount;
  }

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    props: {
      relatedGenre: genres.find((g) => g.slug === 'required-reading'),
      studentMonthlyPrice,
      studentMonthlyPercentageDiscount,
      priceMonthly,
      countryCode,
    },
  };
}

export default withForcePlanToLoggedInUnsubs(Schools);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/for-schools/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  